import {writeBatch} from 'firebase/firestore';
import {firebaseFirestore} from '../../config/firebase';
import getTodoDocRef from './getTodoDocRef';

export default async function untickExpiredTodosDoc(uid: string, todoIds: string[]): Promise<void> {
  if (todoIds.length === 0) return;
  const batch = writeBatch(firebaseFirestore);
  todoIds.forEach((todoId) => {
    batch.update(getTodoDocRef(uid, todoId), {done: null});
  });
  await batch.commit();
}
